import React from 'react';
import './FooterNavigation.scss';
import CuiIcon from '../CuiComponents/Icon';
import { navigate } from '../../redux/actions/CourseActions';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { toast } from 'react-toastify';
import useXapi from '../../Hooks/useXapi';
import { pseudolocalize } from '../Block/common/pseudolocalize/pseudolocalize';

const FooterNavigation = () => {
  const { xApiEvent } = useXapi();
  const dispatch = useDispatch();
  const { nextStep, previousStep, courseId, isPseudo } = useSelector(
    state => ({
      nextStep: state.CourseState.nextStep,
      previousStep: state.CourseState.previousStep,
      courseId: state.CourseState.courseId,
      isPseudo: state.LanguageState.isPseudo
    }),
    shallowEqual
  );

  return (
    <div className="footer-navigation">
      {previousStep && (
        <a
          href={`#${previousStep.url}.1`}
          onClick={e => {
            xApiEvent(
              `Page changed to ${previousStep.url}.1 (previous page) through footer link`,
              window.location.href
            );
            e.preventDefault();
            toast.dismiss();
            // TODO: Refactor toast implementation to use static text instead of <Text /> + <Asset />
            setTimeout(() => {
              dispatch(navigate(previousStep));
            });
          }}
          className="navigation-button navigation-button-left"
        >
          <CuiIcon icon="arrow" />
          <div className="label label--tiny">
            {courseId === previousStep.li ? `` : `${previousStep.li}`}
          </div>
          <span className="navigation-button-label">
            {isPseudo ? pseudolocalize(previousStep.name) : previousStep.name}
          </span>
        </a>
      )}

      {!previousStep && (
        <span className="navigation-button navigation-button-left" />
      )}

      {nextStep && (
        <a
          href={`#${nextStep.url}.1`}
          onClick={e => {
            xApiEvent(
              `Page changed to ${nextStep.url}.1 (next page) through footer link`,
              window.location.href
            );
            e.preventDefault();
            toast.dismiss();
            // TODO: Refactor toast implementation to use static text instead of <Text /> + <Asset />
            setTimeout(() => {
              dispatch(navigate(nextStep));
            });
          }}
          className="navigation-button navigation-button-right"
        >
          <div className="label label--tiny">{nextStep.li}</div>
          <span className="navigation-button-label">
            {isPseudo ? pseudolocalize(nextStep.name) : nextStep.name}
          </span>
          <CuiIcon icon="right-arrow" />
        </a>
      )}
    </div>
  );
};

// connect redux to the Markdown component
export default FooterNavigation;
